package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.TextInputViewController
import com.downdogapp.client.widget.*

actual class TextInputView actual constructor(
  private val controller: TextInputViewController
) : TopLevelView(), View {

  private var inputField: SettingsFormField

  override val root =
    controllerView {
      bg = background(true)
      fg = foreground(true) {
        centeredColumnView {
          pageHeader(
            title = controller.title,
            onBackClicked = controller::onBackClicked
          )

          div {
            marginRight = HORIZONTAL_CONTENT_GUTTER_PX
            marginLeft = HORIZONTAL_CONTENT_GUTTER_PX

            inputField = settingsFormField {
              label = controller.inputLabel

              controller.initialValue?.let {
                setText(it)
              }
            }
          }

          roundedTextButton(
            text = Strings.SAVE,
            marginHorizontal = HORIZONTAL_CONTENT_GUTTER_PX,
            clickFn = ::submitClicked
          ) {
            marginTop = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
          }

          settingsCancelButton(clickFn = controller::onBackClicked)
        }
      }
    }

  private fun submitClicked() {
    controller.submitClicked(inputField.value)
  }

  override fun onBecameVisible() {
    inputField.focus()
  }
}
